import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ListResult } from "../api/core/list-result";
import { MatterDashboardQuestionnaire } from "../api/questionnaire/questionnaire";
import { BACKEND_URL } from "../app.config";


@Injectable()
export class QuestionnaireService {
  constructor(
    private readonly http: HttpClient,
    @Inject(BACKEND_URL) private readonly baseUrl: string
  ) { }

  getList(
    matterId: string = '',
    sorting: string = 'name asc',
    skipCount: number = 0,
    maxResultCount: number = 10
  ): Observable<ListResult<MatterDashboardQuestionnaire>> {
    return this.http.get<ListResult<MatterDashboardQuestionnaire>>(`${this.baseUrl}/api/app/matter/${matterId}/questionnaires`, {
      params: {
        sorting,
        skipCount: skipCount.toString(),
        maxResultCount: maxResultCount.toString()
      }
    });
  }

  getQuestionnaire(matterId: string, questionnaireId: string) {
    return this.http.get(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}`);
  }

  getInternalQuestionnaire(matterId: string, questionnaireId: string, applicantId: string) {
    return this.http.get(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}`);
  }

  getQuestionnaires(matterId: string) {
    return this.http.get(`${this.baseUrl}/api/app/matter/${matterId}/questionnaires`);
  }

  createQuestionnaire(id: string, questionnaireId: string, applicantId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/api/app/matter/${id}/questionnaire/${questionnaireId}`, { applicantId });
  }

  deleteQuestionnaire(id: string, questionnaireId: string, applicantId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/api/app/matter/${id}/questionnaire/${questionnaireId}`, { params: { applicantId } });
    
  }

  getEmailTemplate(matterId: string, questionnaireId: string, applicantId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}/email-template`);
  }

  checkEmail(matterId: string, questionnaireId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/email-check`, null);
  }

  sendQuestionnaire(matterId: string, questionnaireId: string, applicantId: string, data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}/send`, data);
  }

  acceptQuestionnaire(matterId: string, questionnaireId: string, applicantId: string, QuestionnaireJson: any) {
    return this.http.post(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}/accepted`, QuestionnaireJson);
  }

  saveReviewQuestionnaire(matterId: string, questionnaireId: string, applicantId: string, QuestionnaireJson: any) {
    return this.http.post(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}/save`, QuestionnaireJson);
  }

  saveInternalQuestionnaire(matterId: string, questionnaireId: string, applicantId: string, QuestionnaireJson: any) {
    return this.http.post(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}/internal`, QuestionnaireJson);
  }

  updateQuestionnaireStatus(matterId: string, questionnaireId: string, applicantId: string, status: number) {
    return this.http.put(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}/status`, { status: status });
  }

  rejectQuestionnaire(matterId: string, questionnaireId: string, applicantId: string) {
    return this.http.post(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}/reject`, null);
  }

  resetQuestionnaireStatus(matterId: string, questionnaireId: string, applicantId: string) {
    return this.http.post(`${this.baseUrl}/api/app/matter/${matterId}/questionnaire/${questionnaireId}/applicant/${applicantId}/reset`, null);
  }
}
